import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import ProgressBar from '@/components/progress-bar'
import useProfile from '@/hooks/use-profile'
import { breakpoints, structure, zIndex } from '@/styles'
import ApplicationEdit from '../ApplicationEdit'

const Sticky = styled.div`
  position: sticky;
  top: ${structure.header.height}px;
  z-index: ${zIndex.header};
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    top: ${structure.header.heightMobile}px;
  }
`

const ApplicationCompletion = props => {
  const { t } = useTranslation()
  const data = useProfile()
  const completion = data.completion_percentage ?? 0
  return (
    <>
      <Sticky>
        <ProgressBar progress={completion} showPercentage={false} />
      </Sticky>
      <ApplicationEdit
        showLargeHeadings={false}
        title={t('r.application.create.update_profile.title', {
          defaultValue: 'Update Profile ({{ completion }}%)',
          completion
        })}
        heading={t('r.application.create.whats_left.title', "What's left")}
        nextButton={{
          text: t('common.next', 'Next'),
          clickId: 'logged-completed-profile-next-click'
        }}
        autoHide
        {...props}
      />
    </>
  )
}

export default ApplicationCompletion
